<template>
    <div class="ssyhView" v-loading="dataLoading">
        <div v-if="showType == 'list'">
            <!--顶部介绍-->
            <div class="ssyhTopDesc">
                <div class="ssyhTopDescText">{{ showDetaiText.smallText }}</div>
                <div class="ssyhTopDescRight">
                    <div class="ssyhTopDescBtn" @click="openOrCloseTextDetail">查看详情</div>
                </div>
                <div v-if="isShowDetail" class="descDetail">
                    <div class="descDetailContent">
                        <div class="detailClose" @click="openOrCloseTextDetail">
                            <img :src="imgObj.icon_close" alt="">
                        </div>
                        <div class="descDetailAuto">
                            <p class="descDetailTop">
                                <span>{{ showDetaiText.titleLeftText }}</span>
                                <span class="blueSpan">{{ showDetaiText.titleBlue }}</span>
                            </p>
                            <div class="descDetailList"  v-for="(item,index) in showDetaiText.detailList" :key="index">
                                <p class="descDetailListTop">{{ item.title }}</p>
                                <div v-for="(item_c,index_c) in item.desc" :key="index_c">
                                    <p class="descChildList">{{ item_c.text }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--列表-->
            <div class="ssyhType">
                <div 
                    v-if="item.id!='6547439'&&item.id!='1002029'"
                    v-for="(item,index) in treeRange" 
                    :key="index" 
                    class="treeList"
                    :class="tType + 'TreeList'"
                    @click="treeListClick(item)">
                    <p>
                        {{ item.name }}
                    </p>
                </div>
                <div style="clear:both"></div>
            </div>
        </div>
        <div class="resultView" v-if="showType == 'result'">
            <div class="listResultTop">
                <div class="listTopRight">
                    <span>为您匹配</span>
                    <span class="blueSpan blodSpan">{{ total }}项</span>
                    <span>税收优惠政策</span>
                </div>
                <div class="listReturn" @click="resultReturnBtn">返回</div>
            </div>
            <div class="listResultDesc">
                <div class="listResultDescTop">
                    <p>您可结合纳税人实际情况自行判断，也可拨打12366纳税服务热线或者向主管税务机关咨询</p>
                </div>
                <div class="listResultDescBottom">
                    <img :src="imgObj.icon_lingdang" alt="">
                    <span>
                        <span class="redSpan">提示：</span>
                        所推送政策仅供参考，不作为税务部门的执法依据
                    </span>
                </div>
            </div>
            <div class="resultChildBox">
                <div 
                    class="resultChildList"
                    :class="item.total==0?'resultChildListNot':''"
                    v-for="(item,index) in taglist" :key="index"
                    @click="resultChildListClick(item,index)">
                    {{ item.name }}({{ item.total }})
                </div>
                <div style="clear:both"></div>
            </div>
            <div class="uploadMyBG" @click="uploadBG">
                我的报告
            </div>
            <div v-if="isShowSuccessUpload" class="uploadOKWrap">
                <div class="uploadContent">
                    <div class="uploadContentTop">导出成功!</div>
                    <div class="uploadContentText">报告已为您下载到浏览器,请注意查看!</div>
                    <div class="uploadContentOK" @click="uploadSuccessOK">知道了</div>
                </div>
            </div>
        </div>
        <div v-if="showType == 'detail'" class="resultDetailView">
            <div class="listResultTop">
                <div class="listTopRight">
                    <span>政策依据：</span>
                </div>
                <div class="listReturn" @click="detailReturnBtn">返回</div>
            </div>
            <!--政策依据-->
            <div class="detailYJ" v-if="detailData.original_article_no">
                <p class="zcyjTitleP blueSpan" @click="zcyjClick(detailData)">《{{ detailData.original_title }}》</p>
                <p class="zcyjArtP">{{ detailData.original_article_no }}</p>
            </div>
            <!--政策摘要-->
            <div class="listResultZY">
                <p class="listResultZYTop">政策摘要：</p>
                <p class="listResultZYContent" v-html="detailData.content_formatted"></p>
                <p class="listResultZYStatus redSpan">({{ statdata[detailData.status] }})</p>
            </div>
            <!--分页-->
            <div class="deta-fen">
                <div
                    class="fenone"
                     @click="getpage('shang')"
                    :class="{ actfen: detailIndex == 0 }">
                    <img :src="imgObj.icon_zuo" alt="" />
                </div>
                <div class="fener">
                    <p>{{ detailIndex + 1 }} / {{ detailDataAll.length }}</p>
                    <div class="fensi"
                        >跳转到
                        <!-- <input :min="1" :max="detailDataAll.length" @confirm="onConfirm" @blur="onConfirm" type="number" v-model="pageIn" /> -->
                        <input :min="1" :max="detailDataAll.length"  @blur="onConfirm" type="number" v-model="pageIn" />
                        条
                    </div>
                </div>
                <div
                    class="fenone"
                    @click="getpage('xia')"
                    :class="{ actfen: detailIndex == detailDataAll.length - 1 }"
                    >
                    <img :src="imgObj.icon_you" alt="" />
                </div>
            </div>
        </div>
    </div>
</template>
<script>

//图片
import icon_close from '@/assets/icon/close-icon.png';
import icon_lingdang from '@/assets/icon/lingdang.png';
import icon_zuo from '@/assets/icon/zuo.png';
import icon_you from '@/assets/icon/you.png';


//文字json
import { ssyhTextObj } from './text.js'
import utilDate from '@/assets/js/date.js'

//接口
import { getMutexGetTree,getMutexList,getLawsFragment2,getExportPDF } from '@/api/api.js'

export default {
    name:'',
    props:['sendData'],
    data(){
        return{
            imgObj:{
                icon_close,
                icon_lingdang,
                icon_zuo,
                icon_you
            },
            statdata: {
                1: '有效',
                2: '失效',
                3: '部分失效',
                5: '过时',
            },
            //展示形态 list-列表 result-查询结果 
            showType:'list',
            dataLoading:false,
            //分类
            tType:'',
            //是否展示更多的详情
            isShowDetail:false,
            //展示的文字
            showDetaiText:{},
            formItems: [
				{
					type: 'tree',
					data: 'register',
					prop: 'djzclx',
					label: '企业类型',
					isMultiple: false
				},
				{
					type: 'tree',
					data: 'industry',
					prop: 'hy',
					label: '所属行业',
					isMultiple: false
				},
				{
					type: 'tree',
					data: 'Businessscale',
					prop: 'jygm',
					label: '经营规模',
					isMultiple: false
				},
				{
					type: 'tree',
					data: 'Typesofemployment',
					prop: 'yglx',
					label: '用工类型',
					isMultiple: true
				},
				{
					type: 'tree',
					data: 'Preferentialform',
					prop: 'yhxs',
					label: '优惠形式',
					isMultiple: false
				},
				{
					type: 'tree',
					data: 'Policyhierarchy',
					prop: 'zccj',
					label: '政策层级',
					isMultiple: true
				},
				{
					type: 'tree',
					data: 'area',
					prop: 'area',
					label: '所在区域',
					isMultiple: false
				},
				{
					type: 'tree',
					data: 'rpx',
					prop: 'jyfw',
					label: '涉税范围',
					isMultiple: true
				},
				{
					type: 'tree',
					data: 'VATtaxpayer',
					prop: 'zjsnsrlx',
					label: '纳税性质',
					isMultiple: false
				},
				{
					type: 'dateRange',
					label: '执行期限'
				},
				{
					type: 'tree',
					data: 'Specialoffer',
					prop: 'zxyhlx',
					label: '专项优惠',
					isMultiple: false
				},
				{
					type: 'input',
					prop: 'keyword',
					label: '关键字',
					phld: '请输入'
				}
			],
            //标签树
            selectOptions: {
				register: [], //
				area: [],
				industry: [],
				rpx: [],
				Businessscale: [],
				VATtaxpayer: [],
				Typesofemployment: [],
				Preferentialform: [],
				Specialoffer: [],
				Policyhierarchy: []
			},
            formData: {
				djzclx: [], //企业类型
				hy: [], //所属行业
				jygm: [], //经营规模
				yglx: [], //用工类型
				yhxs: [], //优惠形式
				zccj: [], //政策层级
				area: [], //所在区域
				jyfw: [], //涉税范围
				zjsnsrlx: [], //纳税性质
				zxyhlx: [], //专项优惠
				start_date: '',
				end_date: '',
				keyword: '',
				page: 1,
				size: 10,
				export: 1,
				newBusiness: 1,
				status: 1
			},
            queryPDFVO:{
                area:'',
                arbusinessscaleea:'',
                endDate:'',
                industry:'',
                keyWord:'',
                policyhierarchy:'',
                preferentialform:'',
                register:'',
                specialoffer:'',
                startDate:'',
                typesofemployment:'',
                vattaxpayer:'',
                zsxm:'',
            },
            //互斥规则
            mutexList:[],
            treeRange:[], 
            taglist:[],
            optionName:'',
            total:0,
            isShowSuccessUpload:false,
            detailIndex:0,
            detailTotal:'',
            pageIn:1,
            detailData:{},
            detailDataAll:[],
        }
    },
    mounted(){
        this.tType = this.$props.sendData.type
        this.showDetaiText = ssyhTextObj[this.tType];
        //console.log(this.showDetaiText);
        //获取对应的分类数据
        this.getData();
        this.getMutex()
    },
    methods:{
        //展示详情介绍
        openOrCloseTextDetail(){
            this.isShowDetail = !this.isShowDetail;
        },
        getData(){
            this.dataLoading = true;
            let tData = {
                "selected":[],
                "tagType":[
                    "register",
                    "area",
                    "industry",
                    "rpx",
                    "Businessscale",
                    "VATtaxpayer",
                    "Typesofemployment",
                    "Preferentialform",
                    "Specialoffer",
                    "Policyhierarchy"
                ]
            }
            getMutexGetTree(tData).then(res => {
                //console.log(res)
                if(res.status == 200&&res.data.status== 0){
                    let tRes = res.data.data;
                    for (let key in tRes) {
                        this.selectOptions[key] = tRes[key][0].children;
                    }


                    let navBarTitle = {
                        industry: {
                            colIndex: 1,
                            name: '行业'
                        },
                        project: {
                            colIndex: 10,
                            name: '项目'
                        },
                        form: {
                            colIndex: 4,
                            name: '形式'
                        }
                    };
                    
                    let tRole = this.tType=='yhbg'?'form':'project'
                    let col = { ...this.formItems[navBarTitle[tRole].colIndex] };
                    this.$nextTick(() => {
                        this.showTreeSelect(col);
                    });
                    this.dataLoading = false;
                    //console.log(this.selectOptions)
                }
            })
        },
        handleExclusion(id1) {
			let _this = this;
			let mutexIds = []; //需要处理的id
			let mutexData = []; //需要处理的data
			this.mutexList.forEach(item => {
				if (item.tagData == this.currData) {
					let arr = item.tagPath.split('/');
					let id2 = arr[arr.length - 1];
					if (id1 == id2) {
						// console.log(id2,'id2')
						// console.log(item.mutexTagPath,'mutexTagPath')
						let arr3 = item.mutexTagPath.split('/');
						let id3 = arr3[arr3.length - 1];
						mutexIds.push(id3);

						if (mutexData.indexOf(item.mutexTagData) < 0) {
							mutexData.push(item.mutexTagData);
						}
					}
				}
			});
			// console.log(mutexIds,'mutexIds')
			// console.log(mutexData,'mutexData')
			mutexData.forEach(item2 => {
				//递归
				function recursion2(treeData, ids) {
					for (let i = 0; i < treeData.length; i++) {
						let td = treeData[i];
						if (ids.indexOf(td.id + '') > -1) {
							td.hidden = true;
							// console.log(td.name)
						}
						if (td.children && td.children.length > 0) {
							recursion2(td.children, ids);
						}
					}
				}

				recursion2(_this.selectOptions[item2], mutexIds);
			});
		},
        // 显示树选择器
		showTreeSelect(col) {
			let idArr = [];
			let pathArr = [];
			this.formData[col.prop].forEach(item => {
				idArr.push(item.id);
				pathArr.push(item.tagPath);
			});
			// this.$refs.tkitree.currentCheckedId = idArr;
			// this.$refs.tkitree.currentCheckedPath = pathArr;
			this.selectIdFindName(col);
			if (this.currProp != col.prop) {
				//切换下拉框了
				this.currProp = col.prop;
				this.currData = col.data;
				this.isMultiple = col.isMultiple;
				this.treeTitle = '请选择' + col.label;
			}
			this.treeRange = [];
			this.$nextTick(function() {
				this.treeRange = this.selectOptions[col.data];
                //console.log(this.treeRange)
				//this.$refs.tkitree._show(this.role ? false : true);
			});
		},
        selectIdFindName(col) {
			// let _this = this
			// var vArr = []    //用来接收相关联父级id的集合
			// function shellArr(obj,id){
			//   if(obj.length){
			//     obj.forEach(item => {
			//       if (item.children && item.children.length) {
			//         if (item.children.some(row => row.id === id)) {  //这里利用some筛选子级有没有符合条件的，有就重新递归，没有就继续递归
			//           vArr.unshift(item.name)
			//           //重新递归
			//           shellArr(_this.selectOptions[col.data],item.id)
			//         }else{
			//           //继续递归
			//           shellArr(item.children, id)
			//         }
			//       }else{
			// 				return
			// 			}
			//     })
			//   }
			// }
			// shellArr(_this.selectOptions[col.data],_this.formData[col.prop][0].id);
			// console.log(vArr)

			//传入参数：需要遍历的对象，需要匹配的id，获取所有的父级节点的Id
			function findIdList(data2, id, children = 'children', level = 0) {
				var arrRes = [];
				let obj = {
					id: 0,
					[children]: data2
				};
				let rev = (data, id, level) => {
					if (!data || !data[children] || !data[children].length) {
						return;
					}
					for (var i = 0; i < data[children].length; i++) {
						let item = data[children][i];
						if (item.id == id) {
							item.checked = true;
							// 将匹配到的结果保存到数组
							// arrRes.unshift({ level, activeId: item.id });
							arrRes.unshift(item.name);
							// 递归它的父级
							rev(obj, data.id, 0);
							break;
						} else if (item[children] && item[children].length > 0) {
							//如果有子集，则把子集作为参数重新执行本方法
							rev(item, id, level + 1);
						}
					}
				};
				rev(obj, id, level);
				return arrRes;
			}
			let names = [];
			this.formData[col.prop].forEach(item => {
				let name = findIdList(this.selectOptions[col.data], item.id);
				names.push('【' + name.join('-') + '】');
			});
			return names.join('/');
		},
        //获取互斥规则
        getMutex(){
            getMutexList().then(res => {
                //console.log(res)
                if(res.status == 200&&res.data.status== 0){
                    res.data.data.list.forEach(item1 => {
                        let tags = item1.tag.split(',');
                        let mutexTags = item1.mutexTag.split(',');
                        tags.forEach(item2 => {
                            if (item2) {
                                let tag = item2.split(':');
                                mutexTags.forEach(item3 => {
                                    if (item3) {
                                        let mutexTag = item3.split(':');
                                        this.mutexList.push({
                                            tagData: tag[0],
                                            tagPath: tag[1],
                                            method: item1.positive,
                                            mutexTagData: mutexTag[0],
                                            mutexTagPath: mutexTag[1]
                                        });
                                    }
                                });
                            }
                        });
                        mutexTags.forEach(item22 => {
                            if (item22) {
                                let tag = item22.split(':');
                                tags.forEach(item33 => {
                                    if (item33) {
                                        let mutexTag = item33.split(':');
                                        this.mutexList.push({
                                            tagData: tag[0],
                                            tagPath: tag[1],
                                            method: item1.reverse,
                                            mutexTagData: mutexTag[0],
                                            mutexTagPath: mutexTag[1]
                                        });
                                    }
                                });
                            }
                        });
                    });
                    //console.log(this.mutexList)
                }
            })
        },
        //树点击
        treeListClick(obj){
            this.dataLoading = true;
            //console.log(obj);
            this.optionName = obj.name
            let items = []
            items.push({
                id:obj.id,
                tagPath:obj.path,
            })
            let tProp = this.tType == 'yhbg'?'yhxs':'zxyhlx'
            this.formData[tProp] = items;
			// console.log(items, 'items')
			items.forEach(item => {
				this.handleExclusion(item.id);
			});
            //console.log(this.formData)
            setTimeout(() => {
                this.getLawsFragment2(this.formData)
            },100)
        },
        //获取检索结果
        getLawsFragment2(data){
            this.total = 0;
            this.taglist = [];
            getLawsFragment2(data).then(res => {
                if(res.status==200&&res.data.status==0){
                    this.taglist = res.data.data
                    this.taglist.map((it) => {
                        this.total += it.total
                    })
                }
                //console.log(res)
                this.dataLoading = false;
                this.showType = 'result'
            })
        },
        //返回按钮
        resultReturnBtn(){
            this.showType = 'list'
        },
        detailReturnBtn(){
            this.showType = 'result'
            this.detailIndex = 0;
            this.pageIn = 1;
        },
        //点击查询所有 并展示
        resultChildListClick(item,index){
            this.dataLoading = true;
            if(item.total!=0){
                console.log(item);
                console.log(this.formData)

                let tData = JSON.parse(JSON.stringify(this.formData))
                tData.size = item.total;
                if (item.tagId && item.path) {
                    tData.jyfw = [{ id: item.tagId, tagPath: item.path }]
                }
                getLawsFragment2(tData).then(res => {
                    if(res.status==200&&res.data.status==0){
                        console.log(res)
                        if(index == 0){
                            this.detailDataAll = res.data.data[0].data;
                        }else{
                            this.detailDataAll = res.data.data[1].data?res.data.data[1].data:res.data.data[0].data;
                        }
                        this.detailTotal = this.detailDataAll.length;
                        this.detailData = this.detailDataAll[0]
                        // this.detailDataAll = res.data.data
                        // detailTotal:'',
                        // detailData:{},
                        // detailDataAll:{},


                        // this.taglist.map((it) => {
                        //     this.total += it.total
                        // })
                    }
                    //console.log(res)
                    this.dataLoading = false;
                    //this.showType = 'result'

                    this.dataLoading = false;
                    this.showType = 'detail';
                })
            }
        },
        getpage(type) {
            if (type == 'shang') {
                if (this.detailIndex == 0) {
                    this.detailIndex = 0
                    this.pageIn = this.detailIndex + 1
                } else {
                    this.detailIndex--
                    this.pageIn = this.detailIndex + 1
                }
                this.detailData = this.detailDataAll[this.detailIndex]
            } else {
                if (this.detailIndex == this.detailDataAll.length - 1) {
                this.detailIndex = this.detailDataAll.length - 1
                this.pageIn = this.detailIndex + 1
                } else {
                this.detailIndex++
                this.pageIn = this.detailIndex + 1
                }
                this.detailData = this.detailDataAll[this.detailIndex]
            }
        },
        onConfirm(){
            //console.log(this.pageIn - 1)
            this.detailIndex = Number(this.pageIn - 1)
            this.detailData = this.detailDataAll[this.pageIn - 1]
        },
        //分页切换
        pageChange(){
            //this.detailData = this.detailDataAll[0]
        },
        //政策依据点击
        zcyjClick(obj){
            console.log(obj)
            let Detail = this.$router.resolve({path:'/contentSX',query:{contentId:obj.original_id,cId:obj.id}})
            window.open(Detail.href,'_blank')
        },
        //下载报告
        uploadBG(){
            //debugger
            this.dataLoading = true;
            if(this.tType == 'yhbg'){
                this.queryPDFVO.preferentialform = this.optionName
            }else{
                this.queryPDFVO.specialoffer = this.optionName
            }
            let paramsData = JSON.parse(JSON.stringify(this.formData))
            paramsData.queryPDFVO = this.queryPDFVO
            paramsData.size = 5000
            getExportPDF(paramsData).then(res => {
                if(res.status==200){
                    //console.log(res)
                    const content = res.data
                    const blob = new Blob([content])
                    let dateStr = utilDate.formatTime(new Date())
                    let fileName = ''
                    fileName = '定制检索结果-' + dateStr + '.pdf'
                    if ('download' in document.createElement('a')) {
                        // 非IE下载
                        const elink = document.createElement('a')
                        elink.download = fileName
                        elink.style.display = 'none'
                        elink.href = URL.createObjectURL(blob)
                        document.body.appendChild(elink)
                        elink.click()
                        URL.revokeObjectURL(elink.href) // 释放URL 对象
                        document.body.removeChild(elink)
                    } else {
                        // IE10+下载
                        navigator.msSaveBlob(blob, fileName)
                    }

                    this.isShowSuccessUpload = true;
                    this.dataLoading = false;
                }else{
                    this.$message({
                        message:'报告下载失败!',
                        type:'warning'
                    })
                    this.isShowSuccessUpload = false;
                    this.dataLoading = false;
                }
            }).catch(err => {
                console.log(err);
                this.dataLoading = false;
                this.$message({
                    message:'报告下载失败!',
                    type:'warning'
                })
            })
        },
        //知道了
        uploadSuccessOK(){
            this.isShowSuccessUpload = false;
        }
    },
}
</script>
<style scoped lang="scss">
.ssyhView{
    
}
.ssyhTopDesc{
    width:100%;
    height:76px;
    background: #F8F8F8;
    box-sizing: border-box;
    padding:14px;
    .ssyhTopDescText{
        width:calc(100% - 84px);
        height:48px;
        line-height: 24px;
        float:left;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
        font-size:16px;
    }
    .ssyhTopDescRight{
        width:66px;
        height:48px;
        float:left;
        margin-left:18px;
        .ssyhTopDescBtn{
            width:100%;
            height:24px;
            line-height: 24px;
            font-size:14px;
            margin-top:12px;
            cursor:pointer;
            background: #0F59A4;
            color:#ffffff;
            text-align: center;
            border-radius:4px;
        }   
    }
    .descDetail{
        width:100%;
        height: 100vh;
        position: fixed;
        top:0;
        left:0;
        background: rgba(0,0,0,0.5);
        z-index:999;
        .descDetailContent{
            width:610px;
            height:500px;
            margin:200px auto 0;
            position: relative;
            .detailClose{
                width:30px;
                height:30px;
                position: absolute;
                top:-36px;
                right:10px;
                cursor:pointer;
                img{
                    width:100%;
                    height: 100%;
                    z-index: 9999;
                }
            }
            .descDetailAuto{
                width:600px;
                height:500px;
                background: #ffffff;
                margin:200px auto 0;
                border-radius: 20px;
                padding: 20px 20px;
                box-sizing: border-box;
                overflow-y: auto;
                .descDetailTop{
                    width:100%;
                    font-size:16px;
                    line-height: 24px;
                    text-indent: 32px;
                }
                .descDetailList{
                    width:100%;
                    .descDetailListTop{
                        width:100%;
                        font-size:16px;
                        line-height: 24px;
                        text-indent: 32px;
                        font-weight: 700;
                    }
                    .descChildList{
                        width:100%;
                        font-size:16px;
                        line-height: 24px;
                        text-indent: 32px;    
                    }
                }
            }
        }
    }
}

.ssyhType{
    width:100%;
    padding-bottom:10px;
    box-sizing: border-box;
    .treeList{
        display: grid;
        height:45px;
        /*line-height: 45px;*/
        /*text-align: center;*/
        float:left;
        margin-right:20px;
        background: #EEF8FF;
        margin-top:18px;
        box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.2);
        cursor:pointer;
        box-sizing: border-box;
        padding:0 8px;
        font-size:15px;
        p{
            align-self: center;
            /*justify-self: center;*/
            display: -webkit-box;
        }
    }
    .yhbgTreeList:nth-child(5n) {
        margin-right: 0px !important;
    }
    .yhbgTreeList{
        width:calc(20% - 16px);
        
    }
    .xmbgTreeList:nth-child(3n) {
        margin-right: 0px !important;
    }
    .xmbgTreeList{
        width:calc(33.3% - 13.8px);
    }
}

.resultView{
    width:100%;
    position: relative;
    .listResultTop{
        width:100%;
        height:42px;
        position: relative;
        background: #ffffff;
        margin-top:10px;
        box-sizing: border-box;
        padding-left:20px;
        .listTopRight{
            width:calc(100% - 90px);
            height:40px;
            line-height: 40px;
            float:left;
            font-size: 17px;
        }
        .listReturn{
            width:60px;
            height:30px;
            line-height: 30px;
            text-align: center;
            color:#ffffff;
            background: linear-gradient(270deg, #0F59A4 0%, #0F59A4 100%) !important;
            font-size: 15px;
            cursor:pointer;
            position: absolute;
            top:5px;
            right:20px;
            border-radius:2px;
        }
    }
    .listResultDesc{
        width:100%;
        height:70px;
        background: #F8F8F8;
        box-sizing: border-box;
        margin-top:10px;
        padding-left:20px;
        .listResultDescTop{
            width:100%;
            height:40px;
            line-height: 40px;
            font-size:16px;
        }
        .listResultDescBottom{
            width:100%;
            height:24px;
            line-height: 24px;
            font-size:15px;
            img{
                width:16px;
                height:15px;
                margin-right:2px;
                position: relative;
                top:2px;
            }
        }
    }
    .resultChildBox{
        width:100%;
        .resultChildList:nth-child(4n){
            margin-right: 0px !important;
        }
        .resultChildListNot{
            background:#F8F8F8!important;
        }
        .resultChildList{
            width:calc(25% - 8px);
            height:45px;
            line-height: 45px;
            text-align: center;
            float:left;
            margin-right:10px;
            background: #EEF8FF;
            margin-top:18px;
            box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.2);
            cursor:pointer;
            box-sizing: border-box;
            padding:0 8px;
            font-size:14px;
        }
    }
    .uploadMyBG{
        width:30%;
        height:50px;
        line-height: 50px;
        text-align: center;
        margin:30px auto 10px;
        background: #0F59A4;
        color:#ffffff;
        cursor:pointer;
    }
    .uploadOKWrap{
        width:100%;
        height:100%;
        z-index: 999;
        position: absolute;
        top:0;
        left:0;
        .uploadContent{
            width:480px;
            height:210px;
            background: #ffffff;
            margin:20px auto 0;
            box-shadow: 0px 2px 3px 2px rgba(0, 0, 0, 0.2);
            .uploadContentTop{
                width:100%;
                height:80px;
                line-height: 80px;
                text-align: center;
                font-size:18px;
                color:#0F59A4;
                font-weight: 700;
            }
            .uploadContentText{
                width:100%;
                height:30px;
                line-height: 30px;
                text-align: center;
                font-size:16px;
                color: #3D3D3D;
            }
            .uploadContentOK{
                width:120px;
                height:45px;
                line-height: 45px;
                background: #F8F8F8;
                text-align: center;
                cursor:pointer;
                margin:24px auto 0;
            }
        }
    }
}
.resultDetailView{
    width:100%;
    .listResultTop{
        width:100%;
        height:42px;
        position: relative;
        background: #EEF8FF;
        margin-top:10px;
        box-sizing: border-box;
        padding-left:20px;
        .listTopRight{
            width:calc(100% - 90px);
            height:40px;
            line-height: 40px;
            float:left;
            font-size: 17px;
            font-style: italic;
        }
        .listReturn{
            width:60px;
            height:30px;
            line-height: 30px;
            text-align: center;
            color:#ffffff;
            background: linear-gradient(270deg, #0F59A4 0%, #0F59A4 100%) !important;
            font-size: 15px;
            cursor:pointer;
            position: absolute;
            top:5px;
            right:20px;
            border-radius:2px;
        }
    }
    .detailYJ{
        width:100%;
        box-sizing: border-box;
        padding-left:20px;
        .zcyjTitleP{
            cursor:pointer;
            margin-top:10px;
            line-height: 24px;
        }
        .zcyjArtP{
            margin-top:10px;
            font-size: 15px;
        }
    }
    .listResultZY{
        width:100%;
        box-sizing: border-box;
        padding-left:20px;
        margin-top:16px;
        .listResultZYTop{
            font-size: 17px;
            font-style: italic;
        }
        .listResultZYContent{
            line-height:28px ;
            margin-top:12px;
            img{
                width:100%;
            }
        }
        .listResultZYStatus{
            
        }
    }
    .deta-fen {
        /*position: fixed;*/
        /*bottom: 50rpx;*/
        left: 0;
        width: 300px;
        /*margin-left: 30rpx;*/
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin:10px auto 0;
        }
        .fenone {
        width: 32px;
        height: 32px;
        background: #f1f4fa;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        image {
            width: 30rpx;
            height: 25rpx;
        }
    }
    .fener {
        display: flex;
        align-items: center;
        text-align: center;
        p {
            margin-right: 20rpx;
        }
        }
        .fensi {
        display: flex;
        align-items: center;
        input {
            width: 30px;
            border: 1px solid #ccc;
            padding: 2px 10px;
            margin: 0 10px;
        }
    }
}
.blueSpan{
    color:#0F59A4;
}
.redSpan{
    color:red;
}
.blodSpan{
    font-weight: 700;
}

</style>